import fs from 'fs';
import path from 'path';

export const findAppConfig = (cwd: string): string | undefined => {
	const appConfigPath = path.join(cwd, 'app.config.ts');
	if (fs.existsSync(appConfigPath) && fs.statSync(appConfigPath).isFile()) {
		return appConfigPath;
	}

	const subdirectories = fs.readdirSync(cwd);

	for (const subdirectory of subdirectories) {
		const subdirectoryPath = path.join(cwd, subdirectory);

		if (fs.statSync(subdirectoryPath).isDirectory()) {
			const result = findAppConfig(subdirectoryPath);

			if (result) {
				return result;
			}
		}
	}
};

export function addInProviders(updatedAppConfig: string, newProviders: string[]) {
	const providersRegex = /providers:\s*\[\s*([^\]]*)\s*\]/s;
	const providersMatch = updatedAppConfig.match(providersRegex);
	if (providersMatch) {
		// Check if the provider is already added
		if (!newProviders.some((provider) => providersMatch[0].includes(provider))) {
			// Get the content inside the array
			const arrayContent = providersMatch[1].trim();
			// If array is empty, add as first item, otherwise append with comma
			const newArrayContent = arrayContent
				? `${arrayContent}${arrayContent.endsWith(',') ? ' ' : ', '}${newProviders.join(', ')}`
				: newProviders.join(', ');

			updatedAppConfig = updatedAppConfig.replace(
				providersMatch[0],
				`providers: [${newArrayContent}]`
			);
		}
	}
	return updatedAppConfig;
}
